import { render } from "./ViewProduct.vue?vue&type=template&id=1a8c2f80&scoped=true"
import script from "./ViewProduct.vue?vue&type=script&lang=js"
export * from "./ViewProduct.vue?vue&type=script&lang=js"

import "./ViewProduct.vue?vue&type=style&index=0&id=1a8c2f80&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8c2f80"]])

export default __exports__